import { Box, Card, CardContent, Grid, Typography, Container } from '@mui/material';
import LogoSVG from './utils/salutefutura.png';

export default function LoginLayout(props: any) {
    return (
        <Container
            maxWidth="md"
            sx={{
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                px: { xs: 2, sm: 4 },
            }}
        >
            <Card
                sx={{
                    width: '100%',
                    borderRadius: 4,
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    backdropFilter: 'blur(16px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    overflow: 'hidden',
                }}
            >
                <CardContent sx={{ p: 0, pb: '0 !important' }}>          
                    <Grid
                        container
                        direction={{ xs: 'column', md: 'row' }}
                        sx={{ minHeight: { xs: 'auto', md: 500 } }}
                    >
                        <Grid
                            item
                            xs={12}
                            md={5}
                            sx={{
                                background: 'linear-gradient(145deg, var(--button-background-color) 0%, #000 100%)',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                py: { xs: 4, md: 0 },
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: -50,
                                    right: -50,
                                    width: 200,
                                    height: 200,
                                    borderRadius: '50%',
                                    background: 'var(--button-background-color)',
                                    opacity: 0.1,
                                }}
                            />
                            <Box
                                sx={{
                                    position: 'absolute',
                                    bottom: -30,
                                    left: -30,
                                    width: 120,
                                    height: 120,
                                    borderRadius: '50%',
                                    background: 'var(--button-background-color)',
                                    opacity: 0.15,
                                }}
                            />

                            <Box sx={{ textAlign: 'center', zIndex: 1, px: { xs: 2, md: 0 } }}>
                                <Box
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        px: 1.5,
                                        py: 1,
                                        borderRadius: 2,
                                        border: '1px solid rgba(255,255,255,0.35)',
                                        background: 'linear-gradient(135deg, rgba(36,40,48,0.82), rgba(26,30,36,0.68))',
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                                        backdropFilter: 'blur(12px)',
                                        color: 'white',
                                        mb: 1
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={LogoSVG}
                                        alt="Salute Futura"
                                        sx={{ width: { xs: 120, md: 175 } }}
                                    />
                                </Box>

                                <Typography
                                    variant="h2"
                                    sx={{
                                        fontFamily: "'Inter', sans-serif",
                                        fontWeight: 700,
                                        fontSize: { xs: '2rem', md: '3rem' },
                                        background: 'linear-gradient(135deg, #fff 0%, #e2e8f0 100%)',
                                        backgroundClip: 'text',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        letterSpacing: '-0.025em',
                                        mb: 0.5,
                                    }}
                                >
                                    MedPRO
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        fontWeight: 500,
                                        letterSpacing: '0.05em',
                                        textTransform: 'uppercase',
                                        fontSize: '0.875rem',
                                    }}
                                >
                                System
                                </Typography>
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 3,
                                        background: 'var(--button-background-color)',
                                        borderRadius: 2,
                                        mx: 'auto',
                                        mt: 2,
                                    }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={7}>
                            <Box
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    background: 'rgba(255, 255, 255, 0.95)',
                                    backdropFilter: 'blur(10px)',
                                    px: { xs: 2, md: 6 },
                                    py: { xs: 4, md: 0 },
                                }}
                            >
                                {props.children}
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Container>
    );
}
